import { useUser } from '@auth0/nextjs-auth0/client';
import { Box, Container, ContainerProps } from '@mui/material';
import GlobalContentProvider from 'apps/care/components/context/global-content-provider';
import { useEffect } from 'react';
import { AppConfig } from '../../types/app-config';
import { UserPageViewTracking } from './user-pageview-tracking';

export function Layout({
  header = <></>,
  children,
  maxWidth,
  updateConfig,
}: {
  header?: React.ReactNode;
  children?: React.ReactNode;
  config?: AppConfig;
  maxWidth?: ContainerProps['maxWidth'];
  updateConfig?: () => Promise<void>;
}): JSX.Element {
  const { user } = useUser();

  useEffect(
    () => {
      if (!user) {
        return;
      }
      updateConfig();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user],
  );

  const customSX =
    maxWidth === 'xm'
      ? {
          '@media (min-width: 830px)': {
            maxWidth: '830px',
          },
        }
      : {};

  return (
    <GlobalContentProvider>
      <Box
        sx={(theme): object => ({
          backgroundColor: 'var(--mui-sunrise-light-surface-main)',
          color: 'var(--mui-sunrise-light-surface-onMain)',
          minHeight: '100vh',
          paddingBottom: theme.spacing(12),
        })}
      >
        <UserPageViewTracking />
        {header}
        <Container
          maxWidth={maxWidth === 'xm' ? false : 'sm'}
          sx={{
            marginTop: 2.5,
            ...customSX,
          }}
        >
          {children}
        </Container>
      </Box>
    </GlobalContentProvider>
  );
}

export default Layout;
